import React from 'react';
import { observer } from 'mobx-react-lite';
import * as S from './style';
import { useStore } from '../../contexts/MapContext';
import Modal from '../../components/Modal';
import Map from '../../components/Map';
import BottomInfo from '../../components/BottomInfo';
import TopInfo from '../../components/TopInfo';
import Loading from '../../components/Loading';

const App = observer(() => {
  const { openModal, isLoading } = useStore();
  return (
    <S.Container>
      <Map />
      {!openModal && <TopInfo />}
      {!openModal && <BottomInfo />}
      {!isLoading && openModal && <Modal />}
      {isLoading && <Loading />}
    </S.Container>
  );
});

export default App;
